export const PASSPORT_STATUS_OPTIONS = [
  'No passport',
  'Applied',
  'Valid passport',
  'Expired',
] as const;

export function passportStatusOptions(currentValue?: string): string[] {
  const current = currentValue?.trim();
  if (current && !PASSPORT_STATUS_OPTIONS.includes(current as (typeof PASSPORT_STATUS_OPTIONS)[number])) {
    return [current, ...PASSPORT_STATUS_OPTIONS];
  }
  return [...PASSPORT_STATUS_OPTIONS];
}
